<template>
    <div>
        <div v-for="contest in filteredContestList" :key="contest.contestId" class="margin-b" :id="`${contest.title} ${contest.title2}`">
            <h1 id="contest-title">{{`${contest.title} ${contest.title2}`}}</h1>
            <div class="data-table layout">
                <div class="data-table-heading-row row">
                    <div id="table-header" class="base-inline align-l data-table-heading layout-50">
                        <span>{{ $t("LabelCandidateName") }}</span>
                    </div>
                    <div class="align-l base-inline data-table-heading layout-50">
                        <span>{{ $t("LabelStatement") }}</span>
                    </div>
                </div>
                <PublicContestListItem v-if="contest.candidates" :candidates = contest.candidates :contestId = contest.contestId />
                <div v-else>
                    The selected contest doesn't contain any candidates.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import PublicContestListItem from './PublicContestListItem.vue';
export default {
    components: {
        PublicContestListItem
    },
    computed: {
        ...mapState(["contestList", "search"]),
        ...mapGetters(["filteredContestList"]),
    }
}
</script>